import { ROLES } from "aw-consts";
import { menuLine, RouterLink } from "aw-sidebar";
import { useTranslation } from "react-i18next";


export const GeneralConfigRoles = [ROLES.Administrator, ROLES.Demo]
export const CompaniesRoles = [ROLES.Administrator, ROLES.Demo]
export const UsersRoles = [ROLES.Administrator,ROLES.Demo]
export const ContainersRoles = [ROLES.Administrator,ROLES.Demo]
export const MachinesRoles = [ROLES.Administrator, ROLES.Demo]

export const DashboardRoles = [ROLES.Administrator, ROLES.Owner, ROLES.Demo]
export const CanteensDashboardRoles = [ROLES.Administrator, ROLES.Owner,ROLES.Demo]
export const MachinesDashboardRoles = [ROLES.Administrator, ROLES.Owner, ROLES.Demo]

export const Roles3D = [ROLES.Administrator,ROLES.Demo]


export const GetRouteLinks = (): RouterLink[] => {
    const { t } = useTranslation();
    return [

        {
            name: t('ManageCompanies'),
            route: 'companies',
            icon: 'bi bi-house',
            role: CompaniesRoles
        },
        {
            name: t('ManageUsers'),
            route: 'users',
            icon: 'bi bi-people',
            role: UsersRoles
        },
        {
            name: t('ManageInstallations'),
            route: 'containers',
            icon: 'bi bi-geo-alt',
            role: ContainersRoles
        },
        {
            name: t('ManageMachines'),
            route: 'machines',
            icon: 'bi bi-app-indicator',
            role: MachinesRoles
        },
        {
            name: menuLine,
            role: [ROLES.Administrator, ROLES.Demo],
            route: '',
            icon: ''
        },
        {
            name: t('Dashboard'),
            route: 'home',
            icon: 'bi bi-speedometer2',
            role: DashboardRoles
        },
        {
            name: t('Installations'),
            route: 'userInstalations',
            icon: 'bi bi-geo-alt',
            role: CanteensDashboardRoles
        },
        {
            name: t('Machines'),
            route: 'userMachines',
            icon: 'bi bi-app-indicator',
            role: MachinesDashboardRoles
        },
        {
            name: menuLine,
            role: Roles3D,
            route: '',
            icon: ''
        },
        {
            name: t('Modules'),
            route: 'modules',
            icon: 'bi bi-boxes',
            role: Roles3D
        },
        // {
        //     name: t('Demos'),
        //     route: 'demos',
        //     icon: 'bi bi-cloud',
        //     role: Roles3D
        // },

    ]
}